import {
  getMetadata,
  getPermissions,
  setReadOnlyAccess,
} from "@/features/metadata/metadataSlice";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { ACTION, PUBLIC_PATHS, USER_TYPES } from "@/config/constants";
import { Grid, Typography } from "@mui/material";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { setIsReadOnlyPA } from "@/features/proposal-pa/proposalPASlice";

/** Check if the token is stored in the store.
 * Check if token has expired
 * Check for userType & intent and check if user is allowed to access the token.
 */
const Authorize = ({ children }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  // const token = useSelector(getToken);
  const metadata = useSelector(getMetadata);
  const { userType, action } = metadata;
  const permissions = useSelector(getPermissions);

  const [hasAccess, setHasAccess] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const isPublicPath = useCallback(() => {
    return PUBLIC_PATHS.includes(router.pathname);
    // Uncomment below line and comment above line to disable authorization.
    // return true;
  }, [router.pathname]);

  useEffect(() => {
    function handleAuthorization() {
      // If public url then allow access.
      if (isPublicPath()) {
        setHasAccess(true);
        return;
      }
    }

    handleAuthorization();
  }, [
    isPublicPath,
    router.pathname,
    metadata,
    permissions,
    userType,
    dispatch,
    action,
  ]);

  return hasAccess ? (
    <>{children}</>
  ) : (
    <>
      <Grid
        container
        sx={{
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "5rem",
          flexDirection: "column",
        }}
      >
        <Typography variant="h4">Access denied</Typography>
        <Typography variant="body1">{errorMessage}</Typography>
      </Grid>
    </>
  );
};

Authorize.propTypes = {
  children: PropTypes.element,
};

export default Authorize;
